import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import Webcam from "react-webcam";
import { toast } from "react-toastify";

import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
    InputGroup,
    Table,

} from "reactstrap";
import { addJob } from "../../service/api";


const defaultValue = {
    date: "",
    practisc_name: "",
    patient_name: "",
    contactno: "",
    vc_reference: "",
    frame: "",
    frame_type: "",
    lens_type: "",
    surfacing_lab: "",
    reference: "",
    faculty: "",
    notes: "",
}


const LensOrder = () => {

    const [currentDate, setCurrentDate] = useState('');

    useEffect(() => {
        const today = new Date();
        const formattedDate = today.toLocaleDateString();
        setCurrentDate(formattedDate);
        const initialGroupId = Date.now(); // Unique identifier for the group of OD and OS rows
        setFormRows([
            { id: initialGroupId + '-OD', eyeSide: 'OD (R)', groupId: initialGroupId, productpackstyle: '', iofqty: '', iofprice: '', iofamount: '', ioffocQty: '', iofawno: '', iofpdNo: '', iofregNo: '' },
            { id: initialGroupId + '-OS', eyeSide: 'OS (L)', groupId: initialGroupId, productpackstyle: '', iofqty: '', iofprice: '', iofamount: '', ioffocQty: '', iofawno: '', iofpdNo: '', iofregNo: '' }
        ]);
    }, []);



    const [formRows, setFormRows] = useState([{ id: 1, product: '', iofproductname: "", iofqty: "", iofprice: "", iofamount: "", ioffocQty: "", Awno: "", Pdno: "", Regno: "", Regvalidation: "", Ppstatus: "", producrmanufacturer: "" }]);

    // const onAddFormRow = () => {
    //     setFormRows([...formRows,
    //     { id: formRows.length + 1, eyeSide: 'OD (R)', productpackstyle: '', iofqty: '', iofprice: '', iofamount: '', ioffocQty: '', iofawno: '', iofpdNo: '', iofregNo: '' },
    //     { id: formRows.length + 2, eyeSide: 'OS (L)', productpackstyle: '', iofqty: '', iofprice: '', iofamount: '', ioffocQty: '', iofawno: '', iofpdNo: '', iofregNo: '' }
    //     ]);
    // };
    const onAddFormRow = () => {
        const newGroupId = Date.now();

        setFormRows([
            ...formRows,
            { id: newGroupId + '-OD', eyeSide: 'OD (R)', groupId: newGroupId, productpackstyle: '', iofqty: '', iofprice: '', iofamount: '', ioffocQty: '', iofawno: '', iofpdNo: '', iofregNo: '' },
            { id: newGroupId + '-OS', eyeSide: 'OS (L)', groupId: newGroupId, productpackstyle: '', iofqty: '', iofprice: '', iofamount: '', ioffocQty: '', iofawno: '', iofpdNo: '', iofregNo: '' }
        ]);
    };

    const onDeleteFormRow = (groupId) => {
        setFormRows(formRows.filter(row => row.groupId !== groupId));
    };
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* <div className="d-flex justify-content-between align-items-center mb-4">
                        <h1 className="page-title"></h1>
                        <Link to="/Viewpatient" className="btn btn-danger">View Patients</Link>
                    </div> */}
                    {/* Render Breadcrumbs */}
                    {/* <Breadcrumbs title="Dashboard" breadcrumbItem="ADD Patient" /> */}

                    <div className="d-flex justify-content-between align-items-center mb-2">
                        {/* <CardTitle className="mb-4">ADD Patient</CardTitle> */}
                        <h4 className="page-title">ADD ORDER</h4>
                        <Link to="/" className="btn btn-danger">List</Link>
                    </div>
                    <Row>
                        <Card>
                            <CardBody>
                                <h5>UC = UNCOATED   | HC = HARD COATED   | HMC = HARD MULTI COATING   | SHMC = SUPER HYDROPHOBIC MULTI COAT   | PH = PHOTOCHROMIC    | PHF = PHOTOCHROMIC FAST   | WGC = WITH GREEN COATING   | WBC = WITH BLUE COATING    | FCPG = FAST CHANGE PHOTOGREY HMC GREEN   | FCPB = FAST CHANGE PHOTOGREY HMC BLUE   | BC = BLUE CUT   </h5>
                                <br />
                                <Form>
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3 d-flex justify-content-between">
                                                <Label htmlFor="formrow-country-Input">Date: {currentDate}</Label>
                                                <Label htmlFor="formrow-country-Input">ORDER - 019</Label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Supplier :</Label>
                                                <select name="patient_name" className="form-control" onChange={(e) => onValueChange(e)}>
                                                    <option defaultValue>Select Supplier</option>
                                                </select>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <div style={{ width: '100%', overflowX: 'auto' }}>
                                            <Table className="table mb-0" style={{ minWidth: '1200px' }}>
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Eye Side</th>
                                                        <th>Sphere Powder</th>
                                                        <th>Cylinder Powder</th>
                                                        <th>Axis</th>
                                                        <th>Add Powder</th>
                                                        <th>Coating</th>
                                                        <th>FOC Qty</th>
                                                        <th>Function</th>
                                                        <th>Diam</th>
                                                        <th>Index</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {formRows.map((formRow, index) => (
                                                        <tr key={formRow.id}>
                                                            <th scope="row">{formRow.eyeSide}</th>
                                                            <td><Input type="text" className="form-control" value={formRow.productpackstyle} name="productpackstyle" placeholder="SH Right" onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" value={formRow.productpackstyle} name="productpackstyle" placeholder="CYL(Right)" onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" value={formRow.iofqty} name="iofqty" onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" value={formRow.iofprice} name="iofprice" onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" value={formRow.iofamount} name="iofamount" onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" name="ioffocQty" onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" name="iofawno" value={formRow.Awno} onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" name="iofpdNo" value={formRow.Pdno} onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" name="iofregNo" value={formRow.Regno} onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td>
                                                                {index % 2 === 0 && (
                                                                    <div className="d-grid">
                                                                        <input
                                                                            type="button"
                                                                            className="btn btn-danger"
                                                                            value="x"
                                                                            onClick={() => onDeleteFormRow(formRow.groupId)}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>

                                        <Col lg={5} className="d-flex align-items-center">
                                            <input
                                                type="button"
                                                className="btn btn-primary"
                                                value="+"
                                                onClick={onAddFormRow}
                                            />
                                        </Col>
                                    </Row>
                                    {/* <Row>
                                        <div style={{ width: '100%', overflowX: 'auto' }}>
                                            <Table className="table mb-0" style={{ minWidth: '1200px' }}>
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Eye Side</th>
                                                        <th>Sphere Powder</th>
                                                        <th>Cylinder Powder</th>
                                                        <th>Axis</th>
                                                        <th>Add Powder</th>
                                                        <th>Coating</th>
                                                        <th>FOC Qty</th>
                                                        <th>Function</th>
                                                        <th>Diam</th>
                                                        <th>Index</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {formRows.map((formRow, index) => (
                                                        <tr key={formRow.id}>
                                                            <th scope="row">{formRow.eyeSide}</th>
                                                            <td><Input type="text" className="form-control" value={formRow.productpackstyle} name="iofpackStyle" onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" value={formRow.productpackstyle} name="iofpackStyle" onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" value={formRow.iofqty} name="iofqty" onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" value={formRow.iofprice} name="iofprice" onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" value={formRow.iofamount} name="iofamount" onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" name="ioffocQty" onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" name="iofawno" value={formRow.Awno} onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" name="iofpdNo" value={formRow.Pdno} onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td><Input type="text" className="form-control" name="iofregNo" value={formRow.Regno} onChange={(e) => onValueChange(e, index)} /></td>
                                                            <td>
                                                                {index % 2 === 0 && (
                                                                    <div className="d-grid">
                                                                        <input
                                                                            type="button"
                                                                            className="btn btn-danger"
                                                                            value="x"
                                                                            onClick={() => onDeleteFormRow(formRow.groupId)}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>

                                        <Col lg={5} className="d-flex align-items-center">
                                            <input
                                                type="button"
                                                className="btn btn-primary"
                                                value="+"
                                                onClick={onAddFormRow}
                                            />
                                        </Col>
                                    </Row> */}
                                    <br />
                                    <div>
                                        <button className="btn btn-primary w-md mx-2" onClick={(e) => handleSubmit(e)}>
                                            Save
                                        </button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Row>
                </Container>
            </div>
        </React.Fragment >
    )
}

export default LensOrder
